/*
  ED Condition Data
  Shopify asset file: assets/ed-condition-data.js
  Usage in Liquid: {{ 'ed-condition-data.js' | asset_url | script_tag }}
*/
(function () {
  window.ED_CONDITION_DATA = {
    version: "1.0.0",
    source: "User-provided condition and medication list",
    educationalDisclaimer:
      "Educational only. This does not diagnose ED, provide medical advice, or guarantee VA service connection.",

    groups: {
      causesEd: {
        label: "Conditions that can contribute to ED",
        categories: [
          {
            id: "cardiovascular-and-vascular-disorders",
            label: "Cardiovascular & Vascular Disorders",
            items: [
              "Atherosclerosis",
              "Coronary artery disease",
              "Peripheral artery disease",
              "Hypertension",
              "Hypotension",
              "Heart failure",
              "Cardiomyopathy",
              "Arrhythmias",
              "Hyperlipidemia",
              "Hypertriglyceridemia",
              "Metabolic syndrome",
              "Venous leak syndrome",
              "Endothelial dysfunction",
              "Vasculitis",
              "Thromboangiitis obliterans (Buerger disease)",
              "Raynaud disease",
              "Raynaud phenomenon",
              "Aortic aneurysm",
              "Aortic stenosis",
              "Mitral valve disease",
              "Pulmonary hypertension",
              "Chronic venous insufficiency",
              "Deep vein thrombosis",
              "Stroke (CVA)",
              "Transient ischemic attack"
            ]
          },
          {
            id: "endocrine-and-hormonal-disorders",
            label: "Endocrine & Hormonal Disorders",
            items: [
              "Diabetes mellitus type 1",
              "Diabetes mellitus type 2",
              "Prediabetes",
              "Hypogonadism",
              "Low testosterone",
              "Hyperprolactinemia",
              "Pituitary adenoma",
              "Hypothyroidism",
              "Hyperthyroidism",
              "Cushing syndrome",
              "Addison disease",
              "Acromegaly",
              "Klinefelter syndrome",
              "Hemochromatosis",
              "Obesity-related hormonal dysfunction",
              "Insulin resistance",
              "Polycystic endocrine patterns (in men)",
              "Growth hormone deficiency",
              "Androgen insensitivity (partial)",
              "Testicular failure",
              "Leydig cell dysfunction",
              "Hypopituitarism",
              "Thyroiditis",
              "Adrenal tumors",
              "Prolactinoma"
            ]
          },
          {
            id: "neurological-disorders",
            label: "Neurological Disorders",
            items: [
              "Multiple sclerosis",
              "Parkinson disease",
              "Alzheimer disease",
              "Dementia (various types)",
              "Epilepsy",
              "Stroke-related nerve damage",
              "Spinal cord injury",
              "Peripheral neuropathy",
              "Diabetic neuropathy",
              "Autonomic neuropathy",
              "Guillain-Barré syndrome",
              "Amyotrophic lateral sclerosis (ALS)",
              "Huntington disease",
              "Brain tumors",
              "Spina bifida",
              "Cauda equina syndrome",
              "Syringomyelia",
              "Transverse myelitis",
              "Post-polio syndrome",
              "Nerve compression syndromes",
              "Pudendal nerve injury",
              "Pelvic nerve damage",
              "Traumatic brain injury",
              "Chronic migraine (neurologic dysregulation)",
              "Small fiber neuropathy"
            ]
          },
          {
            id: "psychological-and-psychiatric-conditions",
            label: "Psychological & Psychiatric Conditions",
            items: [
              "Major depressive disorder",
              "Generalized anxiety disorder",
              "Performance anxiety",
              "Panic disorder",
              "PTSD",
              "Bipolar disorder",
              "Schizophrenia",
              "Adjustment disorder",
              "Chronic stress",
              "Burnout syndrome",
              "Relationship dysfunction",
              "Sexual performance anxiety",
              "Body image disorders",
              "Substance use disorders",
              "Alcohol use disorder",
              "Sleep deprivation-related anxiety",
              "Obsessive-compulsive disorder",
              "Somatic symptom disorder",
              "Dysthymia",
              "Social anxiety disorder",
              "Trauma-related disorders",
              "Personality disorders",
              "Compulsive sexual behavior disorders",
              "Fear conditioning disorders",
              "Chronic psychological fatigue"
            ]
          },
          {
            id: "urologic-and-reproductive-disorders",
            label: "Urologic & Reproductive Disorders",
            items: [
              "Benign prostatic hyperplasia (BPH)",
              "Prostate cancer",
              "Prostatitis",
              "Peyronie disease",
              "Penile fibrosis",
              "Erectile tissue damage",
              "Testicular cancer",
              "Orchitis",
              "Epididymitis",
              "Varicocele",
              "Hydrocele",
              "Male infertility disorders",
              "Ejaculatory dysfunction disorders",
              "Penile trauma",
              "Pelvic surgery complications",
              "Radical prostatectomy complications",
              "Bladder cancer",
              "Interstitial cystitis",
              "Urethral stricture",
              "Chronic pelvic pain syndrome",
              "Penile vascular insufficiency",
              "Priapism history",
              "Penile nerve injury",
              "Penile fracture (history)",
              "Congenital penile abnormalities"
            ]
          },
          {
            id: "chronic-systemic-diseases",
            label: "Chronic Systemic Diseases",
            items: [
              "Chronic kidney disease",
              "End-stage renal disease",
              "Liver cirrhosis",
              "Chronic liver disease",
              "Chronic obstructive pulmonary disease (COPD)",
              "Sleep apnea",
              "Chronic fatigue syndrome",
              "Fibromyalgia",
              "HIV/AIDS",
              "Cancer (general)",
              "Cachexia",
              "Sarcoidosis",
              "Chronic inflammatory diseases",
              "Systemic lupus erythematosus",
              "Rheumatoid arthritis",
              "Ankylosing spondylitis",
              "Psoriasis (severe)",
              "Chronic infections",
              "Tuberculosis",
              "Sepsis history",
              "Malnutrition",
              "Vitamin deficiencies (B12, D)",
              "Electrolyte imbalance disorders",
              "Chronic pain syndromes",
              "Autoimmune disorders (general)"
            ]
          },
          {
            id: "lifestyle-related-and-metabolic-conditions",
            label: "Lifestyle-Related & Metabolic Conditions",
            items: [
              "Obesity",
              "Sedentary lifestyle syndrome",
              "Smoking-related disease",
              "Alcohol-related organ damage",
              "Substance abuse disorders",
              "Metabolic syndrome",
              "Poor cardiovascular fitness",
              "Chronic dehydration",
              "Overtraining syndrome",
              "Sleep disorders",
              "Insomnia",
              "Circadian rhythm disorders",
              "Poor diet-related disease",
              "Hyperglycemia",
              "Hypoglycemia",
              "Dyslipidemia",
              "Chronic stress physiology",
              "Burnout-related endocrine dysfunction",
              "Sarcopenia",
              "Aging-related decline"
            ]
          },
          {
            id: "infectious-and-inflammatory-conditions",
            label: "Infectious & Inflammatory Conditions",
            items: [
              "Syphilis",
              "Gonorrhea (complications)",
              "Chlamydia (complications)",
              "HPV-related disease",
              "HIV-related neuropathy",
              "Viral orchitis (mumps)",
              "Post-viral syndromes",
              "COVID-19 (vascular/neurologic effects)",
              "Chronic prostatitis (bacterial)",
              "Pelvic inflammatory processes (in men)"
            ]
          },
          {
            id: "trauma-and-structural-causes",
            label: "Trauma & Structural Causes",
            items: [
              "Pelvic fracture",
              "Penile trauma",
              "Spinal injury",
              "Pelvic nerve damage",
              "Surgical complications",
              "Radiation therapy damage",
              "Vascular injury",
              "Perineal trauma",
              "Long-term cycling injury",
              "Compression injuries"
            ]
          },
          {
            id: "miscellaneous-less-common-associations",
            label: "Miscellaneous / Less Common Associations",
            items: [
              "Genetic syndromes affecting vasculature",
              "Connective tissue disorders (Ehlers-Danlos)",
              "Marfan syndrome",
              "Chronic anemia",
              "Polycythemia",
              "Hematologic malignancies",
              "Chronic hypoxia",
              "Environmental toxin exposure",
              "Heavy metal poisoning",
              "Idiopathic erectile dysfunction"
            ]
          }
        ]
      },

      medications: {
        label: "Medications that may contribute to ED",
        categories: [
          {
            id: "medications-a",
            label: "Medications: A",
            items: [
              "abiraterone",
              "acebutolol",
              "alprazolam",
              "amiloride",
              "amiodarone",
              "amitriptyline",
              "amlodipine",
              "amoxapine",
              "amisulpride",
              "amantadine",
              "apomorphine",
              "apalutamide",
              "aripiprazole",
              "asenapine",
              "atenolol",
              "atorvastatin",
              "atropine"
            ]
          },
          {
            id: "medications-b",
            label: "Medications: B",
            items: [
              "benazepril",
              "benztropine",
              "bezafibrate",
              "bicalutamide",
              "biperiden",
              "bisoprolol",
              "bleomycin",
              "brexpiprazole",
              "bromocriptine",
              "brompheniramine",
              "buprenorphine",
              "buspirone",
              "busulfan",
              "butalbital",
              "butorphanol"
            ]
          },
          {
            id: "medications-c",
            label: "Medications: C",
            items: [
              "candesartan",
              "capecitabine",
              "captopril",
              "carbamazepine",
              "carboplatin",
              "carbidopa-levodopa",
              "cariprazine",
              "carvedilol",
              "chlorthalidone",
              "chlorambucil",
              "chlorothiazide",
              "chlorpheniramine",
              "chlorpromazine",
              "chlordiazepoxide",
              "cholestyramine",
              "cimetidine",
              "cisplatin",
              "citalopram",
              "clemastine",
              "clobazam",
              "clofibrate",
              "clomipramine",
              "clonazepam",
              "clonidine",
              "clorazepate",
              "clozapine",
              "codeine",
              "colesevelam",
              "colestipol",
              "cyproheptadine",
              "cyproterone",
              "cytarabine"
            ]
          },
          {
            id: "medications-d",
            label: "Medications: D",
            items: [
              "danazol",
              "darifenacin",
              "darolutamide",
              "dasatinib",
              "daunorubicin",
              "degarelix",
              "desipramine",
              "desvenlafaxine",
              "dexchlorpheniramine",
              "diethylstilbestrol",
              "diazepam",
              "diclofenac",
              "dicyclomine",
              "digoxin",
              "diltiazem",
              "dimenhydrinate",
              "diphenhydramine",
              "disopyramide",
              "divalproex",
              "docetaxel",
              "domperidone",
              "doxazosin",
              "doxepin",
              "doxorubicin",
              "doxylamine",
              "droperidol",
              "duloxetine",
              "dutasteride"
            ]
          },
          {
            id: "medications-e",
            label: "Medications: E",
            items: [
              "enalapril",
              "entacapone",
              "enzalutamide",
              "epirubicin",
              "escitalopram",
              "eszopiclone",
              "estazolam",
              "estradiol",
              "estrogen",
              "ethacrynic acid",
              "ethosuximide",
              "etoposide",
              "ezetimibe"
            ]
          },
          {
            id: "medications-f",
            label: "Medications: F",
            items: [
              "famotidine",
              "fenofibrate",
              "fentanyl",
              "fesoterodine",
              "finasteride",
              "flecainide",
              "fluoxetine",
              "fluorouracil",
              "flupentixol",
              "fluphenazine",
              "flurazepam",
              "fluvoxamine",
              "fluvastatin",
              "fosinopril",
              "furosemide"
            ]
          },
          {
            id: "medications-g",
            label: "Medications: G",
            items: [
              "gabapentin",
              "gemcitabine",
              "gemfibrozil",
              "glycopyrrolate",
              "goserelin",
              "guanabenz",
              "guanethidine",
              "guanfacine"
            ]
          },
          {
            id: "medications-h",
            label: "Medications: H",
            items: [
              "haloperidol",
              "histrelin",
              "hydralazine",
              "hydrochlorothiazide",
              "hydrocodone",
              "hydromorphone",
              "hydroxyzine",
              "hyoscyamine"
            ]
          },
          {
            id: "medications-i",
            label: "Medications: I",
            items: [
              "ibuprofen",
              "ifosfamide",
              "iloperidone",
              "imatinib",
              "imipramine",
              "indapamide",
              "indomethacin",
              "interferon alfa",
              "irbesartan",
              "isocarboxazid"
            ]
          },
          {
            id: "medications-k",
            label: "Medications: K",
            items: ["ketoconazole"]
          },
          {
            id: "medications-l",
            label: "Medications: L",
            items: [
              "labetalol",
              "lacosamide",
              "lamotrigine",
              "levetiracetam",
              "levodopa",
              "levomepromazine",
              "levomilnacipran",
              "lisinopril",
              "loperamide",
              "lorazepam",
              "losartan",
              "loxapine",
              "lurasidone",
              "lumateperone"
            ]
          },
          {
            id: "medications-m",
            label: "Medications: M",
            items: [
              "maprotiline",
              "meclizine",
              "medroxyprogesterone",
              "megestrol",
              "melphalan",
              "meperidine",
              "mesoridazine",
              "metoclopramide",
              "methadone",
              "methotrexate",
              "methyldopa",
              "metolazone",
              "metoprolol",
              "midazolam",
              "milnacipran",
              "minoxidil",
              "mirtazapine",
              "moclobemide",
              "molindone",
              "morphine"
            ]
          },
          {
            id: "medications-n",
            label: "Medications: N",
            items: [
              "nadolol",
              "nalbuphine",
              "naproxen",
              "nebivolol",
              "nefazodone",
              "niacin",
              "nifedipine",
              "nilotinib",
              "nilutamide",
              "nizatidine",
              "nortriptyline"
            ]
          },
          {
            id: "medications-o",
            label: "Medications: O",
            items: [
              "olanzapine",
              "olmesartan",
              "oxazepam",
              "oxcarbazepine",
              "oxycodone",
              "oxymorphone",
              "oxybutynin"
            ]
          },
          {
            id: "medications-p",
            label: "Medications: P",
            items: [
              "paclitaxel",
              "paliperidone",
              "paroxetine",
              "pazopanib",
              "pentazocine",
              "perampanel",
              "perphenazine",
              "phenelzine",
              "phenobarbital",
              "phenoxybenzamine",
              "phentolamine",
              "phenytoin",
              "pimozide",
              "pindolol",
              "pitavastatin",
              "pramipexole",
              "pravastatin",
              "pregabalin",
              "primidone",
              "procarbazine",
              "prochlorperazine",
              "procyclidine",
              "promazine",
              "promethazine",
              "propafenone",
              "propantheline",
              "propoxyphene",
              "propranolol",
              "protriptyline"
            ]
          },
          {
            id: "medications-q",
            label: "Medications: Q",
            items: ["quazepam", "quetiapine", "quinapril"]
          },
          {
            id: "medications-r",
            label: "Medications: R",
            items: [
              "ramipril",
              "ranitidine",
              "relugolix",
              "reserpine",
              "risperidone",
              "ropinirole",
              "rosuvastatin",
              "rotigotine"
            ]
          },
          {
            id: "medications-s",
            label: "Medications: S",
            items: [
              "scopolamine",
              "secobarbital",
              "selegiline",
              "sertraline",
              "simvastatin",
              "solifenacin",
              "sorafenib",
              "sotalol",
              "spironolactone",
              "sulpiride",
              "sunitinib"
            ]
          },
          {
            id: "medications-t",
            label: "Medications: T",
            items: [
              "tapentadol",
              "temazepam",
              "temozolomide",
              "terazosin",
              "thiothixene",
              "thioridazine",
              "tiagabine",
              "timolol",
              "tolcapone",
              "tolterodine",
              "topiramate",
              "torsemide",
              "tramadol",
              "tranylcypromine",
              "trazodone",
              "triazolam",
              "trifluoperazine",
              "trimipramine",
              "triprolidine",
              "trospium"
            ]
          },
          {
            id: "medications-v",
            label: "Medications: V",
            items: [
              "valproic acid",
              "valsartan",
              "venlafaxine",
              "verapamil",
              "vigabatrin",
              "vilazodone",
              "vinblastine",
              "vincristine",
              "vortioxetine"
            ]
          },
          {
            id: "medications-z",
            label: "Medications: Z",
            items: [
              "zaleplon",
              "ziprasidone",
              "zolpidem",
              "zonisamide",
              "zuclopenthixol"
            ]
          }
        ]
      },

      edCanCauseOrWorsen: {
        label: "Conditions ED can cause or worsen",
        categories: [
          {
            id: "mental-health-conditions",
            label: "Mental Health Conditions",
            items: [
              "Anxiety",
              "Performance Anxiety",
              "Depression",
              "Chronic Stress",
              "Panic Attacks",
              "Sleep Disturbances",
              "Insomnia",
              "Low Self-Esteem",
              "Social Withdrawal"
            ]
          },
          {
            id: "relationship-and-emotional-conditions",
            label: "Relationship & Emotional Conditions",
            items: [
              "Relationship Problems",
              "Loss of Intimacy",
              "Emotional Disconnection",
              "Marital Stress",
              "Reduced Confidence",
              "Sexual Avoidance",
              "Emotional Isolation"
            ]
          },
          {
            id: "hormonal-and-physical-health-conditions",
            label: "Hormonal & Physical Health Conditions",
            items: [
              "Low Testosterone",
              "Chronic Fatigue",
              "Reduced Physical Performance",
              "Weight Gain",
              "Obesity (from inactivity/depression cycles)",
              "Reduced Libido"
            ]
          },
          {
            id: "cardiovascular-and-stress-related-conditions",
            label: "Cardiovascular & Stress-Related Conditions",
            items: [
              "High Blood Pressure (stress-induced hypertension)",
              "Increased Cardiovascular Stress",
              "Worsening Heart Health Due to Chronic Stress",
              "Poor Sleep-Related Cardiovascular Strain"
            ]
          },
          {
            id: "lifestyle-and-behavioral-conditions",
            label: "Lifestyle & Behavioral Conditions",
            items: [
              "Alcohol Dependence",
              "Substance Abuse",
              "Physical Inactivity",
              "Sedentary Lifestyle",
              "Poor Sleep Habits"
            ]
          },
          {
            id: "quality-of-life-conditions",
            label: "Quality of Life Conditions",
            items: [
              "Reduced Quality of Life",
              "Decreased Motivation",
              "Reduced Emotional Well-Being",
              "Loss of Confidence in Relationships",
              "Reduced Overall Life Satisfaction"
            ]
          }
        ]
      }
    },

    resultCopy: {
      causesEd:
        "This selection may be relevant because it can be associated with blood flow, nerve, hormone, mental health, medication, or systemic health pathways that can contribute to ED.",
      medications:
        "This medication appears on your medication list as potentially associated with ED. A clinician can help evaluate whether timing, dosage, or alternatives matter.",
      edCanCauseOrWorsen:
        "This selection may be relevant as something ED can contribute to or worsen through stress, sleep, confidence, relationship strain, inactivity, or quality-of-life pathways."
    }
  };

  window.EDConditionDataHelpers = {
    slugify: function (value) {
      return String(value || "")
        .toLowerCase()
        .replace(/&/g, " and ")
        .replace(/[^a-z0-9]+/g, "-")
        .replace(/^-+|-+$/g, "");
    },

    flatten: function () {
      var data = window.ED_CONDITION_DATA;
      var rows = [];

      Object.keys(data.groups).forEach(function (groupKey) {
        var group = data.groups[groupKey];

        group.categories.forEach(function (category) {
          category.items.forEach(function (item) {
            rows.push({
              id:
                groupKey +
                "__" +
                category.id +
                "__" +
                window.EDConditionDataHelpers.slugify(item),
              groupKey: groupKey,
              groupLabel: group.label,
              categoryId: category.id,
              categoryLabel: category.label,
              label: item,
              searchText: [item, category.label, group.label]
                .join(" ")
                .toLowerCase()
            });
          });
        });
      });

      return rows;
    },

    search: function (query, groupKey) {
      var q = String(query || "").trim().toLowerCase();

      return window.EDConditionDataHelpers.flatten().filter(function (row) {
        if (groupKey && row.groupKey !== groupKey) return false;
        if (!q) return true;

        return row.searchText.indexOf(q) !== -1;
      });
    },

    getResultText: function (groupKey) {
      return (
        window.ED_CONDITION_DATA.resultCopy[groupKey] ||
        window.ED_CONDITION_DATA.educationalDisclaimer
      );
    }
  };
})();